import { errorMessage } from "helpers/utils";
import { call, put, takeEvery } from "redux-saga/effects";
import menuService from "services/menuService";
import { getMenuFail, getMenuSuccess } from "store/actions";
import { GET_MENU } from "./actionTypes";

function* fetchGetMenu({ payload }) {
  try {
    const response = yield call(menuService.getMenu);
    yield put(getMenuSuccess(response));
  } catch (error) {
    yield put(getMenuFail(errorMessage(error)));
  }
}

function* menuSaga() {
  yield takeEvery(GET_MENU, fetchGetMenu);
}

export default menuSaga;
